<template>
    <div class="text-input">
        <label><b>{{label}}</b></label>
        <div class="form-group">

            <select class="form-control"
                    :placeholder="placeholder"
                    v-model="displayValue"
                    @change="updateManager"
                    :disabled="disabled"
                    :aria-label="{label}">
                <option :value="0">None</option>
                <option v-for="(pm, index) in potentialManagers"
                        :key="pm.SalesRepId"
                        :value="pm.SalesRepId">{{ pm.FirstName }} {{ pm.LastName }}</option>
            </select>
            <i class="fa fa-chevron-down"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ManagerSelect",
        props: {
            potentialManagers: {
                type: Array,
            },
            label: {
                type: String,
            },
            placeholder: {
                type: String,
            },
            value: {
                type: Number,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        data(){
            return {
                displayValue: null
            }
        },
        methods: {
            updateManager($event){
                let managerId = Number($event.target.value);
                this.$emit('input',managerId);
            }
        },
        watch: {
            value: function(){
                this.displayValue = this.value;
            }
        },
        created(){
            this.displayValue = this.value;
        }
    }
</script>

<style scoped lang="scss">
    .form-group{
        margin-bottom: 0px;
        select {
            -webkit-appearance: none;
            -moz-appearance: none;
            -o-appearance: none;
            /* no standardized syntax available, no ie-friendly solution available */
        }
        select + i.fa {
            float: right;
            margin-top: -26px;
            margin-right: 5px;
            background: inherit;
            /* this is so when you click on the chevron, your click actually goes on the dropdown menu */
            pointer-events: none;
            /* everything after this is just to cover up the original arrow */
            /* (for browsers that don't support the syntax used above) */
            padding-right: 5px;
        }
    }
</style>
